import {Card} from 'antd';
import PropTypes from 'prop-types';
import React, {memo} from 'react';

import EntityMenu from '@/components/EntityMenu';
import TableData from '@/components/TableGrid/TableData';
import AdminHeader from '@/components/TableGrid/TableHeader';
import {useDialogsContext} from '@/contexts/DialogsContext';
import {ADD_HANDLER_DIALOG} from '@/utils/createEntityContainer';

const TableGrid = ({
  tableTitle,
  tableSubTitle,
  extras,
  columns,
  useTableData,
  canSelect,
  rowActions,
  actionsLabel,
  addLabel,
  translation,
  selectedActions,
  filters,
  canAdd,
  extraFilters,
  route,
  useCreatePath,
  searchPlaceholder,
  canSearch,
  pageConfig,
  entityName,
  hasTable = true,
  showAdminHeader = true,
  onAdd,
  tabs,
  ...props
}) => {
  const {openDialog} = useDialogsContext(ADD_HANDLER_DIALOG);
  
  if (rowActions && !columns.some(c => c.dataIndex === 'actions')) {
    columns.push(
      {
        title: actionsLabel,
        dataIndex: 'actions',
        width: 100,
        align: 'center',
        // eslint-disable-next-line react/display-name
        render: (text, record) => (
          <EntityMenu data={record}/>
        )
      }
    );
  }
  
  return (
    <Card className={'responsive-card'}>
      {showAdminHeader &&
        <AdminHeader
          tableHook={useTableData}
          pageConfig={pageConfig}
          title={tableTitle}
          subTitle={tableSubTitle}
          onAdd={onAdd || openDialog}
          useCreatePath={useCreatePath}
          route={route}
          addLabel={addLabel}
          extras={extras}
          hasTable={hasTable}
          canAdd={canAdd}
          extraFilters={extraFilters}
          canSearch={canSearch}
          filters={filters}
          translation={translation}
          entityName={entityName}
          searchPlaceholder={searchPlaceholder}
          tabs={tabs}
        />}
      {tabs}
      <TableData
        selectedActions={selectedActions}
        tableHook={useTableData}
        canSelect={canSelect}
        {...props}/>
    </Card>
  );
  
};

TableGrid.propTypes = {
  pageConfig: PropTypes.object,
  actionsLabel: PropTypes.string,
  addLabel: PropTypes.string,
  canSelect: PropTypes.bool,
  canSearch: PropTypes.bool,
  columns: PropTypes.array,
  extras: PropTypes.node,
  filters: PropTypes.any,
  tabs: PropTypes.any,
  onAdd: PropTypes.func,
  route: PropTypes.string,
  rowActions: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  selectedActions: PropTypes.func,
  tableHook: PropTypes.func,
  tableTitle: PropTypes.string.isRequired,
  tableSubTitle: PropTypes.string,
  translation: PropTypes.string,
  translationPrefix: PropTypes.string,
  useCreatePath: PropTypes.bool,
  useTableData: PropTypes.func.isRequired,
  canAdd: PropTypes.bool,
  extraFilters: PropTypes.bool,
  useMapColumns: PropTypes.any,
  searchPlaceholder: PropTypes.any,
  entityName: PropTypes.any,
  hasTable: PropTypes.bool,
  showAdminHeader: PropTypes.bool,
};

TableGrid.defaultProps = {
  canAdd: true,
  canSearch: true,
  extraFilters: false
};

export default memo(TableGrid);
